import { getEdgeUrl } from '@/lib/getEdgeUrl';
import { Content } from './types';

const smartphonesDesktop = getEdgeUrl(
  'images/homepage/banner/v2/smartphones-desktop.png',
);
const smartphonesMobile = getEdgeUrl(
  'images/homepage/banner/v2/smartphones-mobile.png',
);
const LaptopsDesktop = getEdgeUrl('images/homepage/banner/laptops-desktop.png');
const LaptopsMobile = getEdgeUrl('images/homepage/banner/laptops-mobile.png');
const IpadsDesktop = getEdgeUrl('images/homepage/banner/ipads-desktop.png');
const IpadsMobile = getEdgeUrl('images/homepage/banner/ipads-mobile.png');

const smartwatchesDesktop = getEdgeUrl(
  'images/homepage/banner/v2/smartwatches-desktop.png',
);
const smartwatchesMobile = getEdgeUrl(
  'images/homepage/banner/v2/smartwatches-mobile.png',
);

const CONFIG: Content[] = [
  {
    title: 'Premium Smartphones. Better Prices.',
    description: {
      desktop:
        'Expertly refurbished, quality guaranteed, with savings up to 70% less than new.',
      mobile:
        'Expertly refurbished, quality guaranteed, with savings up to 70% less than new.',
    },
    cta: {
      label: 'Shop Now',
      link: 'smartphones',
      tracking: 'Smartphones',
    },
    banner: { desktop: smartphonesDesktop, mobile: smartphonesMobile },
    theme: 'light',
  },
  {
    title: 'Refurbished Laptops',
    description: {
      desktop:
        'Explore a wide variety of expertly refurbished laptop picks - up to 70% off.',
      mobile: 'Expertly refurbished laptop picks up to 70% off.',
    },
    cta: {
      label: 'Shop Now',
      link: 'laptops',
      tracking: 'Laptops',
    },
    banner: { desktop: LaptopsDesktop, mobile: LaptopsMobile },
    theme: 'light',
  },
  {
    title: 'Refurbished iPads',
    description: {
      desktop:
        'On the go or on the fly - refurbished iPad upgrades that can get it done.',
      mobile:
        'On the go or on the fly - refurbished iPad that can get it done.',
    },
    cta: {
      label: 'Shop Now',
      link: 'apple-ipads',
      tracking: 'iPads',
    },
    banner: { desktop: IpadsDesktop, mobile: IpadsMobile },
    theme: 'dark',
  },
  {
    title: 'Refurbished Smartwatches',
    description: {
      desktop:
        'Smarter moves, sleeker looks — refurbished smartwatches that keep up and stand out.',
      mobile:
        'Smarter moves, sleeker looks — refurbished smartwatches that keep up and stand out.',
    },
    cta: {
      label: 'Shop Now',
      link: 'smartwatches',
      tracking: 'Smartwatches',
    },
    banner: { desktop: smartwatchesDesktop, mobile: smartwatchesMobile },
    theme: 'light',
  },
];

export default CONFIG;
